import React from "react";

export const BigSpin = () => (
    <div className="text-center">
        <img src="/spin.svg" alt="loader" />
    </div>
);
